export default {
	countryCode: "Country code",
};
